import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('DASHBOARD_IN_DEVELOPMENT_SERVICE_PLAN')